<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/css/reset.css'

  function loadJs(url) {
      var headDoc = document.getElementsByTagName('head')[0];
      var js = document.createElement('script');
      js.setAttribute('type', 'text/javascript');
      js.setAttribute('src', url);
      headDoc.appendChild(js);
  }
  loadJs('//j1.58cdn.com.cn/wmda/js/statistic_v000.js');
  window.WMDA_SDK_CONFIG = ({
      api_v: 1,
      sdk_v: 0.1,
      mode: 'report',
      appid: 8258448750517,
      key: 'rfvx825c',
      project_id: '8047512742452',
      SPA_HASH: true, //单页应用必选
  });
export default {
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue